export default __webpack_public_path__ + "static/media/colony_cluster.3fe9f79f.jpg";